import React, { useEffect } from 'react';
import {
  DropdownWrapper,
  FilterDropdownButton,
  FilterOptionsList,
  FilterOptionItem,
  FilterSearchInput,
} from '../GenerateOffer.styles';
import { ChevronDownIcon, ChevronUpIcon, DotIcon } from '../icons';

export default function FilterDropdown({
  value,
  onChange,
  options,
  placeholder,
  children,
  showSearch = true,
}) {
  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState('');
  const ref = React.useRef(null);

  const close = () => { setOpen(false); setQuery(''); };

  useEffect(() => {
    if (!open) return;
    const h = e => { if (ref.current && !ref.current.contains(e.target)) close(); };
    document.addEventListener('mousedown', h);
    document.addEventListener('scroll', h, true);
    const onWheel = (e) => {
      const t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'number' && ref.current && ref.current.contains(t)) {
        e.preventDefault();
      }
    };
    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => {
      document.removeEventListener('mousedown', h);
      document.removeEventListener('scroll', h, true);
      document.removeEventListener('wheel', onWheel, { capture: true });
    };
  }, [open]);

  useEffect(() => {
    if (open) setQuery('');
  }, [open]);

  const selected = options.find(o => o.value === value);
  const filteredOptions = options.filter(o => {
    const lowerQuery = query.toLowerCase();
    return o.label.toLowerCase().includes(lowerQuery);
  });

  return (
    <DropdownWrapper ref={ref}>
      <FilterDropdownButton
        type="button"
        data-open={open}
        data-placeholder={!selected}
        onClick={() => setOpen(o => !o)}
      >
        <span>{selected ? selected.label : placeholder}</span>
        {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </FilterDropdownButton>
      {open && (
        <FilterOptionsList>
          {showSearch && (
            <li style={{ padding: '2px 4px' }}>
              <FilterSearchInput
                placeholder="Filtruj..."
                value={query}
                onChange={e => setQuery(e.target.value)}
              />
            </li>
          )}
          {children && (
            <li style={{ padding: '8px 12px' }}>
              {children}
            </li>
          )}
          {filteredOptions.map(o => {
            const sel = o.value === value;
            return (
              <FilterOptionItem
                key={o.value}
                data-selected={sel}
                onClick={() => { onChange(o.value); close(); }}
              >
                <span className="option-content">
                  {sel && <DotIcon />}
                  <span className="option-label">{o.label}</span>
                </span>
              </FilterOptionItem>
            );
          })}
          {!filteredOptions.length && (
            <FilterOptionItem data-selected={false} style={{ cursor: 'default', opacity: 0.7 }}>
              <span className="option-content">
                <span className="option-label">Brak wyników</span>
              </span>
            </FilterOptionItem>
          )}
        </FilterOptionsList>
      )}
    </DropdownWrapper>
  );
}
